import { jsx as _jsx } from "react/jsx-runtime";
import { MessagesSquare, PlugZap, MessageSquareText, SlidersHorizontal } from 'lucide-react';
import { createModulePerms } from '@wit-support/ui-domain';
import { SocialConnectionsPage } from './routes/connections.js';
import { SocialCommentsPage } from './routes/comments.js';
import { SocialCommentCardPage } from './routes/comment-card.js';
import { SocialSettingsPage } from './routes/settings.js';
// Fail-closed: модуль вне провайдера шелла показывает раздел только для чтения.
const { Provider: SocialModulePermsProvider, usePerms: useSocialPerms } = createModulePerms({ canManage: false, canManageConnections: false });
export { SocialModulePermsProvider, useSocialPerms };
function ConnectionsRoute() {
    const { canManage, canManageConnections } = useSocialPerms();
    return (_jsx(SocialConnectionsPage, { canManage: canManage, canManageConnections: canManageConnections }));
}
function CommentsRoute() {
    const { canManage } = useSocialPerms();
    return _jsx(SocialCommentsPage, { canManage: canManage });
}
function CommentCardRoute() {
    const { canManage } = useSocialPerms();
    return _jsx(SocialCommentCardPage, { canManage: canManage });
}
function SettingsRoute() {
    const { canManage, canManageConnections } = useSocialPerms();
    return _jsx(SocialSettingsPage, { canManage: canManage, canManageConnections: canManageConnections });
}
/**
 * Раздел «Соцсети» — реагирование на комментарии под нашими постами через
 * шлюз admin-api `/api/social/*` к модулю комментариев движка
 * `wit_video_combine`.
 *
 * Модуль отсоединяемый: импортирует только кит (`ui`, `ui-domain`,
 * `ui-forms`), `admin-client-core` и `admin-contracts` — от модуля «Контент»
 * не зависит (ссылка на пост — внешняя), его можно поднять в отдельной
 * админке с `MODULES = [socialModule]`.
 */
export const socialModule = {
    id: 'social',
    label: 'Соцсети',
    icon: MessagesSquare,
    permission: 'social.read',
    workspace: 'content',
    order: 11,
    description: 'Комментарии под нашими постами: подключение токенов, журнал комментариев, ответы и настройки реагирования.',
    showInNav: true,
    // Страницы — пунктами бокового меню. В пространстве «Контент» два модуля,
    // поэтому шелл вкладывает их под пункт «Соцсети».
    sectionsPlacement: 'sidebar',
    sections: [
        { path: '/', label: 'Подключения', icon: PlugZap },
        { path: '/comments', label: 'Комментарии', icon: MessageSquareText },
        { path: '/settings', label: 'Настройки реагирования', icon: SlidersHorizontal },
    ],
    // Статические маршруты объявлены ДО `$id`.
    routes: [
        { path: '/', component: ConnectionsRoute },
        { path: '/comments', component: CommentsRoute, label: 'Комментарии' },
        { path: '/settings', component: SettingsRoute, label: 'Настройки реагирования' },
        { path: '/comments/$id', component: CommentCardRoute, label: 'Комментарий' },
    ],
};
export { SocialConnectionsPage } from './routes/connections.js';
export { SocialCommentsPage } from './routes/comments.js';
export { SocialCommentCardPage } from './routes/comment-card.js';
export { SocialSettingsPage } from './routes/settings.js';
export { setSocialApiBaseUrl } from './api.js';
//# sourceMappingURL=index.js.map